import {
    Component,
    EventEmitter,
    Input,
    Output,
    HostAttributeToken,
    inject,
    ChangeDetectionStrategy
} from '@angular/core';

@Component({
    selector: 'ceres-simple-card',
    templateUrl: './simple-card.component.html',
    styleUrls: ['./simple-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleCardComponent {
    @Input()
    title = '';

    @Input()
    extendable = false;

    @Input()
    hideChildren = false;

    @Output()
    hiddenChanged = new EventEmitter<boolean>();

    isSubCard: boolean;

    constructor() {
        const isSubCard = inject(new HostAttributeToken('isSubCard'), { optional: true });

        this.isSubCard = !!isSubCard;
    }

    toggleHide() {
        this.hideChildren = !this.hideChildren;
        this.hiddenChanged.emit(this.hideChildren);
    }

    doNothing(event: MouseEvent) {
        event.stopPropagation();
    }
}
